import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const ConversationDetails = ({ conversation, messages, onClose }) => {
  const sharedFiles = messages?.filter(msg => msg?.attachments?.length > 0) || [];
  const proposals = messages?.filter(msg => msg?.is_proposal) || [];

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-border flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">Details</h3>
        <button
          onClick={onClose}
          className="p-1 hover:bg-muted rounded transition-smooth"
        >
          <Icon name="X" size={18} />
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        {/* Participant Info */}
        <div className="text-center">
          <div className="w-20 h-20 rounded-full overflow-hidden bg-muted mx-auto mb-3">
            <Image
              src={conversation?.otherParticipant?.avatar_url || '/assets/images/no_image.png'}
              alt={`${conversation?.otherParticipant?.full_name || 'User'} avatar`}
              className="w-full h-full object-cover"
            />
          </div>
          <h4 className="font-semibold text-foreground mb-1">
            {conversation?.otherParticipant?.full_name || 'Unknown User'}
          </h4>
          <p className="text-sm text-muted-foreground capitalize">
            {conversation?.otherParticipant?.role || 'User'}
          </p>
        </div>

        {/* Shared Files */}
        <div>
          <h5 className="text-sm font-medium text-foreground mb-3 flex items-center gap-2">
            <Icon name="Paperclip" size={16} />
            Shared Files ({sharedFiles?.length})
          </h5>
          {sharedFiles?.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">
              No files shared yet
            </p>
          ) : (
            <div className="space-y-2">
              {sharedFiles?.slice(0, 5)?.map((msg) =>
                msg?.attachments?.map((attachment) => (
                  <div
                    key={attachment?.id}
                    className="p-2 bg-muted rounded-lg hover:bg-muted/80 transition-smooth cursor-pointer"
                  >
                    <div className="flex items-center gap-2">
                      <Icon name="File" size={16} className="text-muted-foreground" />
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-medium text-foreground truncate">
                          {attachment?.file_name}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {formatDate(msg?.created_at)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* Proposals */}
        <div>
          <h5 className="text-sm font-medium text-foreground mb-3 flex items-center gap-2">
            <Icon name="FileText" size={16} />
            Proposals ({proposals?.length})
          </h5>
          {proposals?.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">
              No proposals yet
            </p>
          ) : (
            <div className="space-y-2">
              {proposals?.map((msg) => (
                <div
                  key={msg?.id}
                  className="p-3 bg-muted rounded-lg border border-border"
                >
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <p className="text-xs font-medium text-foreground">
                      ${msg?.proposal_data?.budget?.toLocaleString()}
                    </p>
                    <span
                      className={`text-xs px-2 py-0.5 rounded-full capitalize ${
                        msg?.proposal_data?.status === 'accepted' ?'bg-green-500/10 text-green-600'
                          : msg?.proposal_data?.status === 'rejected' ?'bg-red-500/10 text-red-600' :'bg-yellow-500/10 text-yellow-600'
                      }`}
                    >
                      {msg?.proposal_data?.status}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {formatDate(msg?.created_at)}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Conversation Info */}
        <div className="pt-4 border-t border-border">
          <div className="space-y-2 text-xs">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Started</span>
              <span className="text-foreground">
                {formatDate(conversation?.createdAt)}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Messages</span>
              <span className="text-foreground">{messages?.length || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationDetails;